import { UserApiUserUpdatePhoneVerifyRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation'

export const useUserUpdatePhoneVerifyMutation = () =>
  useBaseMutation({
    mutationFn: (req: UserApiUserUpdatePhoneVerifyRequest, config) =>
      appApiClient.userApi.userUpdatePhoneVerify(req, config),
  })
